 var SearchCloseIcon = $('.hs-search-drawer-2 .close-icon')
function OpenSearchDrawer() {
    $('body').addClass('hs-open-search');
    $('html').addClass('hs-open-drawer')
    $('.hs-desktop-content-search').addClass('active');
}

function CloseSearchDrawer() {
    $('body').removeClass('hs-open-search');
    $('html').removeClass('hs-open-drawer')
    $('.hs-desktop-content-search').removeClass('active');
}
$(document).on('click', '.header__icon--search', function() {
    OpenSearchDrawer();
})
$(document).on('click', '.hs-close-search-drawer', function() {
    CloseSearchDrawer();
});
$(document).on('click', '.hs-bg-slide-search', function() {
    CloseSearchDrawer();
})
function RenderSingleProductSearchItem(product) {
    var singleProduct = "";
    singleProduct += '<div class="sp-product">';
    singleProduct += '<div class="product-image"><a href="' + product.url + '"><img src="' + product.image + '"> </a></div>';
    singleProduct += '<div class="sp-product-tile">' + product.title + '</div>';
    singleProduct += '<div class="sp-product-heading">'+(product.usptext ? product.usptext : '')+'</div>';

    singleProduct += '<div class="one-time-button">';
    singleProduct += '<a href="' + product.url + '">View product</a>';
    singleProduct += '</div>';
    singleProduct += '</div>';
    return singleProduct;
}

function generateSearchDrawerHtml(response, keyword) {
    var progressBar = $('.search-products .Pagination-module_bar');
      progressBar.css({ left:0,width:0})
    var productHtml = "";
    $('.search-products').hide();
    if (response.product && response.product.length > 0) {
       var $carousel = $('.sp-products-list');
        if ($carousel.hasClass('slick-initialized')) {
            $carousel.slick('unslick');
            $('.sp-products-list').html(productHtml);

        }
        response.product.forEach(function(item, index) {
            var itemHtml = RenderSingleProductSearchItem(item);
            productHtml += itemHtml;
        });
        $('.search-products').show();
        $('.sp-products-list').html(productHtml);
      
      var SearchDrawerProductslider =  $carousel.slick({
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows:true,
      });
      var ssl = response.product.length;
      progressBar.css('width',100/ssl+'%')
       SearchDrawerProductslider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          var calc = ((nextSlide) / (slick.slideCount)) * 100;
           progressBar.css('left',calc+'%')
      });
    }
   
 
   
    $('.search-articles').hide();
    if (response.article && response.article.length > 0) {
        var articleHtml = '<div class="articles-list-search">';
        response.article.forEach(function(article, index) {
            if (index < 3) {
               articleHtml += '<a href="'+article.url+'" style="text-decoration: none;">';
                  articleHtml += '<div class="single-article">';
                  articleHtml += '<div class="article-title">' + article.title + '</div>';
                  articleHtml += '<div class="article-content">' + article.content + '</div>';
                  articleHtml += '</div>';
              articleHtml += '</a>';
            }
        });
        articleHtml += '</div>';
        $('.search-articles').show();
        $('.sp-articles-list').html(articleHtml);
        $('.view-more-articles').hide()
        if (response.article.length > 4) {
            $('.view-more-articles').show();
            $('.see-more-link').attr('href', '/search?q=' + keyword + '&type=article')
        }
    }
}

function ReinitSearchDrawer() {
    var $carousel = $('.sp-products-list');
    if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
    }
    $('.search-products').hide();
    $('.search-articles').hide();
}
$(document).on('change keyup paste mouseup keydown', '.search-drawer-text', function(e) {
   var q = $(this).val();
    if (q != '') {
       SearchCloseIcon.addClass('visible');
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,article';
        url = '/search?q=' + encodeURIComponent(q) + '&view=json';
        $.ajax(url, {
            type: 'GET',
            dataType: 'json',
            success: function(response) {
                var result = {};
                response.results.forEach(function(item, index) {
                    if (!result[item.object_type]) {
                        result[item.object_type] = [];
                    }
                    result[item.object_type].push(item);
                })
                generateSearchDrawerHtml(result, encodeURIComponent(q));
            }
        });
    } else {
        SearchCloseIcon.removeClass('visible')
        ReinitSearchDrawer()
    }
});
 $(document).on('click', '.hs-search-drawer-2 .close-icon', function(e) {
   $('.search-drawer-text').val('')
   SearchCloseIcon.removeClass('visible');
    ReinitSearchDrawer()
 })

// https://www.marahnatural.com/search/suggest.json?q=mara&resources[type]=product,article,page